import React from "react";
import { Radar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  RadarController,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Title,
  Legend,
  CategoryScale,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";

ChartJS.register(
  RadarController,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Title,
  Legend,
  CategoryScale,
  ChartDataLabels
);

const RadarChart = ({ data }) => {
  const labels = ["Senior Management", "Compensation", "Career Opportunities"];
  const dataValues = [
    data.senior_management_rating,
    data.compensation_rating,
    data.career_opportunities_rating,
  ];

  const filteredLabels = labels.filter(
    (_, index) => dataValues[index] !== undefined && dataValues[index] !== null
  );
  const filteredDataValues = dataValues.filter(
    (value) => value !== undefined && value !== null
  );

  const chartData = {
    labels: filteredLabels,
    datasets: [
      {
        label: "Ratings",
        data: filteredDataValues,
        backgroundColor: "rgba(255, 99, 132, 0.2)",
        borderColor: "rgba(255, 99, 132, 1)",
        borderWidth: 1,
        pointBackgroundColor: "rgba(255, 99, 132, 1)",
      },
    ],
  };

  const options = {
    maintainAspectRatio: false, // Disable aspect ratio to allow full control of height
    scales: {
      r: {
        angleLines: {
          display: false,
        },
        min: 0,
        max: 5,
        beginAtZero: true,
        ticks: {
          display: false,
        },
        pointLabels: {
          font: {
            size: 16,
            weight: "bold",
          },
          color: "var(--gray-600)",
          padding: 24,
        },
      },
    },
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: false,
      },
      datalabels: {
        display: true,
        align: "end",
        anchor: "end",
        borderRadius: 20,
        borderWidth: 1,
        padding: 6,
        font: {
          size: 12,
          weight: "normal",
        },
        formatter: (value) => value.toFixed(2),
        color: function (context) {
          const value = context.dataset.data[context.dataIndex];
          return value >= 4 ? "var(--success-700)" : value >= 3 ? "var(--warning-700)" : "var(--error-700)";
        },
        backgroundColor: function (context) {
          const value = context.dataset.data[context.dataIndex];
          return value >= 4 ? "var(--success-50)" : value >= 3 ? "var(--warning-50)" : "var(--error-50)";
        },
        borderColor: function (context) {
          const value = context.dataset.data[context.dataIndex];
          return value >= 4 ? "var(--success-200)" : value >= 3 ? "var(--warning-200)" : "var(--error-200)";
        },
      },
    },
  };

  return (
    <div style={{ width: "100%", height: "450px" }}>
      <Radar data={chartData} options={options} />
    </div>
  );
};

export default RadarChart;
